import React from "react";
import { Stack, Box, Divider, Typography } from "@mui/material";
import { WhereToVote, PhoneIphone, Phone, Email } from "@mui/icons-material";

export const FooterThree = ({ translate }) => {
  return (
    <Box>
      <Box>
        <Typography variant="h6">
          <b>{translate("contactUs")}</b>
        </Typography>
      </Box>
      <Divider sx={{ border: "2px solid #669944", width: "160px", my: 1 }} />
      <Box>
        <Stack direction="column" pl={2}>
          <Stack direction="row" alignItems="center" py={1}>
            <WhereToVote sx={{ fontSize: "20px" }} />
            <Typography
              variant="body1"
              sx={{
                paddingLeft: "10px",
              }}
            >
              {translate("contactUsFooterCompany")}
            </Typography>
          </Stack>
          <Typography variant="body1" sx={{ width: { xs: "100%", md: "80%" } }}>
            {translate("contactUsFooterAddress")}
          </Typography>
          <Stack direction="row" alignItems="center" py={1}>
            <PhoneIphone sx={{ fontSize: "20px" }} />
            <Typography
              variant="body1"
              sx={{
                paddingLeft: "10px",
              }}
            >
              {translate("contactUsFooterMobilePhone")}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" py={1}>
            <Phone sx={{ fontSize: "20px" }} />
            <Typography
              variant="body1"
              sx={{
                paddingLeft: "10px",
              }}
            >
              {translate("contactUsFooterFixLinePhone")}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" py={1}>
            <Email sx={{ fontSize: "20px" }} />
            <Typography
              variant="body1"
              sx={{
                paddingLeft: "10px",
              }}
            >
              {translate("contactUsFooterEmail")}
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};
